import React from 'react';

const DeleteIcon = () => {
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M8.33333 9.16601V14.166M11.6667 9.16601V14.166M15.8333 4.99935V16.666C15.8333 17.108 15.6577 17.532 15.3452 17.8445C15.0326 18.1571 14.6087 18.3327 14.1667 18.3327H5.83333C5.39131 18.3327 4.96738 18.1571 4.65482 17.8445C4.34226 17.532 4.16667 17.108 4.16667 16.666V4.99935M2.5 4.99935H17.5M6.66667 4.99935V3.33268C6.66667 2.89065 6.84226 2.46673 7.15482 2.15417C7.46738 1.84161 7.89131 1.66602 8.33333 1.66602H11.6667C12.1087 1.66602 12.5326 1.84161 12.8452 2.15417C13.1577 2.46673 13.3333 2.89065 13.3333 3.33268V4.99935'
        stroke='#6E7079'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default DeleteIcon;
